/**
 * reviewRoutes — the two Needs-review routes (BON-381), defined here rather
 * than inline in `AdminRoutes.tsx` so the route table, its permission gate and
 * the pages it mounts all live together in this feature folder. `<Routes>`
 * expands a fragment transparently, so this drops into the app's route list as
 * one entry. Paths are relative — admin mode's tree mounts them under
 * `/admin/*`.
 *
 * Both routes carry the same gate as the API reads (`read:bookings` OR the
 * `read:all` admin sentinel); the narrower `write:payment-reviews` gates the
 * resolve/reopen affordances inside the detail page, not access to the page.
 */
import { Route } from 'react-router-dom';

import RequirePermission from '../../shared/RequirePermission';
import { Permission } from '../../types/permissions';

import ReviewDetailPage from './ReviewDetailPage';
import ReviewQueuePage from './ReviewQueuePage';

const READ_ANY_OF = [Permission.READ_BOOKINGS, Permission.READ_ALL];

export const reviewRoutes = (
  <>
    <Route
      path="needs-review"
      element={
        <RequirePermission anyOf={READ_ANY_OF}>
          <ReviewQueuePage />
        </RequirePermission>
      }
    />
    <Route
      path="needs-review/:kind/:id"
      element={
        <RequirePermission anyOf={READ_ANY_OF}>
          <ReviewDetailPage />
        </RequirePermission>
      }
    />
  </>
);
